import React, { createContext, useState, useEffect, useContext } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

const DisplayPreferencesContext = createContext({
  showPrices: true,
  isUnderMaintenance: false,
  maintenanceMessage: '',
  loading: true,
});

export function DisplayPreferencesProvider({ children }) {
  const [state, setState] = useState(() => {
    try {
      const cached = localStorage.getItem('displayPreferences');
      if (cached) {
        const parsed = JSON.parse(cached);
        return {
          showPrices: parsed.showPrices !== false,
          isUnderMaintenance: parsed.isUnderMaintenance === true,
          maintenanceMessage: parsed.maintenanceMessage || '',
          loading: true,
        };
      }
    } catch {}
    return { showPrices: true, isUnderMaintenance: false, maintenanceMessage: '', loading: true };
  });

  useEffect(() => {
    const unsubscribe = onSnapshot(
      doc(db, 'website_display_preferences', 'default'),
      (snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.data();
          const prefs = {
            showPrices: data.show_prices !== false,
            isUnderMaintenance: data.is_under_maintenance === true,
            maintenanceMessage: data.maintenance_message || '',
            loading: false,
          };
          setState(prefs);
          try {
            localStorage.setItem('displayPreferences', JSON.stringify(prefs));
          } catch {}
        } else {
          setState({ showPrices: true, isUnderMaintenance: false, maintenanceMessage: '', loading: false });
        }
      },
      (error) => {
        console.error('Error fetching display preferences:', error);
        setState((prev) => ({ ...prev, loading: false }));
      }
    );

    return () => unsubscribe();
  }, []);

  return (
    <DisplayPreferencesContext.Provider value={state}>
      {children}
    </DisplayPreferencesContext.Provider>
  );
}

export function useDisplayPreferences() {
  return useContext(DisplayPreferencesContext);
}
